import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CLASS_RESTORE, getProviderAllClasses, getProviderClasses, PROVIDER_GET_CLASSES, resetState, StateStatus } from '@guryou/redux';

const useClasses = (serviceId, all = false) => {
  const dispatch = useDispatch();
  const { data, status, version, entity, request } = useSelector(state => state.classes.all);
  const restore = useSelector(state => state.classes.restore);

  useEffect(() => {
    if (!serviceId) {
      return;
    }
    if (status === StateStatus.NOT_INITIALIZED || (status === StateStatus.LOADED && request?.serviceId !== serviceId)) {
      if (all) {
        dispatch(getProviderAllClasses(serviceId));
      } else {
        dispatch(getProviderClasses(serviceId));
      }
    }
    if (restore.version) {
      dispatch(resetState(PROVIDER_GET_CLASSES));
      restore.version && dispatch(resetState(CLASS_RESTORE));
    }
  }, [all, data, dispatch, request, restore.version, serviceId, status]);

  if (!serviceId) {
    return { data: null, status: StateStatus.NOT_INITIALIZED };
  }

  return { data: data || [], status, version, entity };
};

export default useClasses;
